import '../assets/NcAppSettingsSection-DnDcGk1v.css';
import { createElementBlock, openBlock, createElementVNode, renderSlot, createCommentVNode, toDisplayString } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _sfc_main = {
  name: "NcAppSettingsSection",
  inject: ["registerSection", "unregisterSection"],
  props: {
    name: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true,
      validator(id) {
        return /^[a-z0-9\-_]+$/.test(id);
      }
    }
  },
  computed: {
    // generate an id for each settingssection based on the name without whitespaces
    htmlId() {
      return "settings-section_" + this.id;
    }
  },
  // Reactive changes for section navigation
  watch: {
    id(newId, oldId) {
      this.unregisterSection(oldId);
      this.registerSection(newId, this.name, this.$slots?.icon?.());
    },
    name(newName) {
      this.unregisterSection(this.id);
      this.registerSection(this.id, newName, this.$slots?.icon?.());
    }
  },
  mounted() {
    this.registerSection(this.id, this.name, this.$slots?.icon?.());
  },
  beforeUnmount() {
    this.unregisterSection(this.id);
  }
};
const _hoisted_1 = ["id", "aria-labelledby"];
const _hoisted_2 = ["id"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("section", {
    id: $options.htmlId,
    "aria-labelledby": `${$options.htmlId}--label`,
    class: "app-settings-section"
  }, [
    createElementVNode("h3", {
      id: `${$options.htmlId}--label`,
      class: "app-settings-section__name"
    }, toDisplayString($props.name), 9, _hoisted_2),
    renderSlot(_ctx.$slots, "default", {}, void 0, true),
    createCommentVNode("", true)
  ], 8, _hoisted_1);
}
const NcAppSettingsSection = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-ce8fac13"]]);
export {
  NcAppSettingsSection as N
};
//# sourceMappingURL=NcAppSettingsSection-CssmXyZ0.mjs.map
